export default __webpack_public_path__ + "static/media/failedobjective.21768118.svg";